export default __webpack_public_path__ + "static/media/moon.2f684774.jpg";